// test2377
(2377 && 0);
